import { render, staticRenderFns } from "./ModernPhoneInput.vue?vue&type=template&id=37ddcce2&"
import script from "./ModernPhoneInput.vue?vue&type=script&lang=js&"
export * from "./ModernPhoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports